import { FC } from "react";
import imagePng from "images/back-right.png";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import {useHistory} from "react-router-dom";

export interface SectionHeroProps {
  className?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "" }) => {
  const navigate = useHistory();
  return (
    <div
      className={`nc-SectionHero flex flex-col-reverse lg:flex-col relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-10 pb-14 lg:pb-64 xl:pr-14 lg:mr-10 xl:mr-0">
          <h2 className="font-medium text-4xl md:text-5xl xl:text-7xl !leading-[114%] ">
          Ink Your Dreams
          </h2>
          <span className="text-base md:text-lg text-neutral-500 dark:text-neutral-400">
          Start your tattoo journey by finding the right artist today and bring your unique story to life on your skin.
          </span>
          <ButtonPrimary onClick={() => {
                navigate.push('/artists-search')}}>Find Your Artist</ButtonPrimary>
        </div>
        <div className="flex-grow">
          <img className="w-full" src={imagePng} alt="hero" />
        </div>
      </div>

      {/* <div className="z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
        <HeroSearchForm />
      </div> */}
    </div>
  );
};

export default SectionHero;
